module.exports = "<textarea id=\"{{elementId}}\"></textarea>\n"


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/helpers/editor/editor.component.html
// module id = ../../../../../src/app/helpers/editor/editor.component.html
// module chunks = main